/*
 * duo-fidget-icons.js  —  gamified SVG icons for the Fidget Match-3 gems.
 * Replaces the product-photo tiles with cohesive, chunky flat icons so the
 * board reads like a game, not a catalog. One style system: 64x64 viewBox,
 * bold flat fills, soft darker outlines, rounded joins. Inlined into each tile
 * so CSS can animate + drop-shadow them.
 *
 * Browser (window.DuoFidgetIcons) + Node (module.exports). `get(id)` returns
 * the inner SVG markup; `svg(id)` wraps it in an <svg>. One icon per catalog id.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.DuoFidgetIcons = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  // Each value is the INNER markup of a 0 0 64 64 svg.
  var I = {
    'wish-upon-a-star-magnetic-fidget':
      '<path d="M32 5l7.6 17.6 19.1 1.6-14.5 12.5 4.4 18.7L32 45.6 15.4 55.9l4.4-18.7L5.3 24.7l19.1-1.6z" fill="#f9c61b" stroke="#dca400" stroke-width="2.4" stroke-linejoin="round"/>',

    'cat-paw-magnetic-fidget':
      '<ellipse cx="32" cy="43" rx="15.5" ry="12.5" fill="#fe6a76"/>' +
      '<circle cx="17.5" cy="28" r="5.6" fill="#fe6a76"/><circle cx="27.5" cy="22" r="6.2" fill="#fe6a76"/>' +
      '<circle cx="37" cy="22" r="6.2" fill="#fe6a76"/><circle cx="47" cy="28" r="5.6" fill="#fe6a76"/>',

    'dog-paw-fidget-magnet':
      '<path d="M32 30c9 0 16 6 16 13s-7 11-16 11-16-4-16-11 7-13 16-13z" fill="#a9743f"/>' +
      '<circle cx="17.5" cy="29" r="6" fill="#a9743f"/><circle cx="27.5" cy="22" r="6.6" fill="#a9743f"/>' +
      '<circle cx="37" cy="22" r="6.6" fill="#a9743f"/><circle cx="47" cy="29" r="6" fill="#a9743f"/>',

    'mama-bear-magnetic-fidget':
      '<g fill="#e98ab0"><ellipse cx="32" cy="44" rx="14.5" ry="12.5"/><circle cx="18" cy="31" r="5.8"/>' +
      '<circle cx="27.5" cy="25" r="6.2"/><circle cx="37" cy="25" r="6.2"/><circle cx="46.5" cy="31" r="5.8"/></g>' +
      '<g fill="#7a4a5e"><path d="M16 24l1.6 3.4 1.6-3.4z"/><path d="M25.4 18l1.6 3.4 1.6-3.4z"/>' +
      '<path d="M35 18l1.6 3.4 1.6-3.4z"/><path d="M44.6 24l1.6 3.4 1.6-3.4z"/></g>' +
      '<ellipse cx="32" cy="42" rx="6.5" ry="6" fill="#f8c2d8"/>',

    'papa-bear-magnetic-fidget':
      '<g fill="#6fa8dc"><ellipse cx="32" cy="44" rx="14.5" ry="12.5"/><circle cx="18" cy="31" r="5.8"/>' +
      '<circle cx="27.5" cy="25" r="6.2"/><circle cx="37" cy="25" r="6.2"/><circle cx="46.5" cy="31" r="5.8"/></g>' +
      '<g fill="#3f6896"><path d="M16 24l1.6 3.4 1.6-3.4z"/><path d="M25.4 18l1.6 3.4 1.6-3.4z"/>' +
      '<path d="M35 18l1.6 3.4 1.6-3.4z"/><path d="M44.6 24l1.6 3.4 1.6-3.4z"/></g>' +
      '<ellipse cx="32" cy="42" rx="6.5" ry="6" fill="#a9cdee"/>',

    'mushroom-magic-magnetic-fidget':
      '<rect x="25" y="33" width="14" height="22" rx="7" fill="#f1e3c4"/>' +
      '<path d="M8 37a24 17 0 0 1 48 0z" fill="#ef4a3f" stroke="#c9362d" stroke-width="2"/>' +
      '<circle cx="21" cy="29" r="3.4" fill="#fff"/><circle cx="34" cy="24" r="4.2" fill="#fff"/><circle cx="45" cy="30" r="3" fill="#fff"/>',

    'boo-bliss-ghost-magnetic-fidget':
      '<path d="M14 31a18 18 0 0 1 36 0v23l-6-5.5-5.5 5.5L32 54l-6.5-5L20 54l-6-5.5z" fill="#ece7fb" stroke="#cdc4ef" stroke-width="2.2" stroke-linejoin="round"/>' +
      '<circle cx="25" cy="31" r="3.3" fill="#33305a"/><circle cx="39" cy="31" r="3.3" fill="#33305a"/>',

    'pizza-please-magnetic-fidget':
      '<path d="M32 7l23 45a3 3 0 0 1-2.7 4.3H11.7A3 3 0 0 1 9 52z" fill="#f3c23f" stroke="#dba62f" stroke-width="2.2" stroke-linejoin="round"/>' +
      '<path d="M14.5 53h35l-2.2 4.3H16.7z" fill="#e0a23a"/>' +
      '<circle cx="27" cy="33" r="4" fill="#e23b2e"/><circle cx="39" cy="38" r="4" fill="#e23b2e"/><circle cx="30" cy="47" r="3.4" fill="#e23b2e"/>',

    'taco-magnetic-fidget':
      '<path d="M9 47c0-15 10-24 23-24s23 9 23 24z" fill="#edb24c" stroke="#cf9433" stroke-width="2.2" stroke-linejoin="round"/>' +
      '<path d="M13 31q19-10 38 0-9 7-19 7T13 31z" fill="#57bd5b"/>' +
      '<circle cx="24" cy="30" r="3.1" fill="#e8554a"/><circle cx="40" cy="30" r="3.1" fill="#e8554a"/><circle cx="32" cy="33" r="3.1" fill="#f6e7b3"/>',

    'pickle-please-magnetic-fidget':
      '<rect x="23" y="13" width="18" height="40" rx="9" fill="#6fae3a" stroke="#56892c" stroke-width="2"/>' +
      '<ellipse cx="28" cy="23" rx="2" ry="3" fill="#8fc752"/><ellipse cx="35" cy="30" rx="2" ry="3" fill="#8fc752"/>' +
      '<ellipse cx="30" cy="40" rx="2" ry="3" fill="#8fc752"/><ellipse cx="36" cy="45" rx="2" ry="3" fill="#8fc752"/>',

    'egg-magnetic-fidget':
      '<path d="M22 50c-9 0-15-7-11-15 2-5-1-9 4-13s11 1 14-2 12-3 14 5 8 7 6 14-8 7-14 6-7 5-12 5-3-5-1-5z" fill="#fffdf7" stroke="#eadfca" stroke-width="2"/>' +
      '<circle cx="33" cy="33" r="9" fill="#f9b81b"/><circle cx="30" cy="30" r="3" fill="#ffd866"/>',

    'bacon-bliss-sensory-fidget':
      '<path d="M7 26q8-7 15 0t15 0 15 0l3 7q-7 7-15 0t-15 0-15 0z" fill="#cf4636"/>' +
      '<path d="M7 26q8-7 15 0t15 0 15 0" fill="none" stroke="#f0d9c2" stroke-width="3.4" stroke-linecap="round"/>' +
      '<path d="M9 39q8-7 15 0t15 0 13 0l2 6q-6 6-13 0t-15 0-15 0z" fill="#d65846"/>',

    'hot-sauce-fidget-magnet':
      '<rect x="23" y="20" width="18" height="34" rx="5" fill="#d8352a" stroke="#ad281f" stroke-width="1.6"/>' +
      '<rect x="28" y="12" width="8" height="9" fill="#b32a20"/><rect x="26" y="8" width="12" height="6" rx="2" fill="#3a3f4a"/>' +
      '<rect x="26" y="33" width="12" height="15" rx="2" fill="#fff7ef"/>' +
      '<path d="M32 36c2 2 3 4 3 6a3 3 0 0 1-6 0c0-1.5 1-2.5 1.5-3.5 0 1 .5 1.5 1.5 1.5 0-1.5-1-2.5 0-4z" fill="#e8554a"/>',

    'orange-spritz-unwind-fidget-magnet':
      '<rect x="30" y="40" width="4" height="11" fill="#d9b88a"/><rect x="23" y="51" width="18" height="3" rx="1.5" fill="#d9b88a"/>' +
      '<path d="M19 16h26l-3.5 20a9.5 9.5 0 0 1-19 0z" fill="#fb9a3a" stroke="#e07d1e" stroke-width="1.8"/>' +
      '<rect x="40" y="7" width="2.6" height="16" rx="1.3" fill="#e8554a" transform="rotate(14 41 15)"/>' +
      '<circle cx="40" cy="20" r="5.2" fill="#f97316" stroke="#fff" stroke-width="1.4"/>',

    'espresso-martini-fidget':
      '<rect x="30.5" y="36" width="3" height="14" fill="#d9cdbb"/><rect x="22" y="50" width="20" height="3" rx="1.5" fill="#d9cdbb"/>' +
      '<path d="M13 16h38L34 39h-4z" fill="#efe9dc" stroke="#cdc4b2" stroke-width="1.8"/>' +
      '<path d="M18 19h28L33.5 34h-3z" fill="#3b2417"/>' +
      '<ellipse cx="28" cy="20" rx="2.6" ry="1.7" fill="#23150c"/><ellipse cx="36" cy="20" rx="2.6" ry="1.7" fill="#23150c"/><ellipse cx="32" cy="22.5" rx="2.6" ry="1.7" fill="#23150c"/>',

    'killer-calm-true-crime-magnetic-fidget':
      '<path d="M31 6c3.5 9 3.5 22 3.5 31h-7C27.5 28 27.5 15 31 6z" fill="#d2d7de" stroke="#aab1bc" stroke-width="1.6" stroke-linejoin="round"/>' +
      '<rect x="25.5" y="36" width="13" height="21" rx="4.5" fill="#2b2c2f"/>' +
      '<path d="M32 11c2.2 4 2.2 7.5 0 10-2.2-2.5-2.2-6 0-10z" fill="#e23b2e"/>',

    'chalk-it-out-true-crime-magnetic-fidget':
      '<rect x="37" y="38" width="18" height="7" rx="3.5" fill="#3a3f4a" transform="rotate(45 40 41)"/>' +
      '<circle cx="27" cy="27" r="15" fill="#fff" stroke="#3a3f4a" stroke-width="4"/>' +
      '<g fill="none" stroke="#d24b3f" stroke-width="1.8" stroke-linecap="round"><circle cx="27" cy="27" r="3"/>' +
      '<path d="M27 19a8 8 0 0 1 8 8"/><path d="M27 35a8 8 0 0 1-8-8"/></g>',

    'reel-relief-fish-fidget':
      '<path d="M44 32l13-10v20z" fill="#3a9db2"/>' +
      '<path d="M10 32q15-14 36 0-15 14-36 0z" fill="#4bb3c9" stroke="#3a9db2" stroke-width="1.6"/>' +
      '<path d="M27 19q7-3 12 2-6 2-12-2z" fill="#3a9db2"/>' +
      '<circle cx="20" cy="30" r="2.6" fill="#16363f"/>',

    'lighter-days-fidget':
      '<rect x="22" y="26" width="20" height="30" rx="6" fill="#7e6bf0"/>' +
      '<ellipse cx="28" cy="38" rx="6" ry="9" fill="#4bc0d9" opacity=".7"/><ellipse cx="38" cy="44" rx="5" ry="7" fill="#fe6a9a" opacity=".7"/>' +
      '<rect x="24" y="18" width="16" height="10" rx="2" fill="#cfd4db"/>' +
      '<path d="M32 4c3 4 5 6 5 9a5 5 0 0 1-10 0c0-2.5 1.5-4 2.5-5.5 0 2 1 3 2.5 3 0-3-1-4 0-6.5z" fill="#fb8c2a"/>' +
      '<path d="M32 9c1.4 2 2.2 3.4 2.2 5a2.2 2.2 0 0 1-4.4 0c0-1.2.8-2 1.4-2.8 0 1 .4 1.4 1 1.4 0-1.4-.6-2 0-3.6z" fill="#ffd34d"/>',

    'leaf-it-be-monstera-leaf-fidget':
      '<rect x="30.5" y="40" width="3" height="16" fill="#2a8a4e"/>' +
      '<path d="M32 7C17 11 9 26 12 44c4 2 9 3 20 3s16-1 20-3C55 26 47 11 32 7z" fill="#2fae62" stroke="#249152" stroke-width="1.6"/>' +
      '<g fill="#249152"><path d="M32 12v32"/><path d="M21 22q-5 6-6 14M43 22q5 6 6 14M25 16q-3 8-3 16M39 16q3 8 3 16" stroke="#249152" stroke-width="1.6" fill="none"/></g>' +
      '<path d="M20 30q4 2 8 0M36 30q4 2 8 0M26 40q3 2 6 0M32 40q3 2 6 0" stroke="#1f7a45" stroke-width="2" fill="none" stroke-linecap="round"/>',

    'bloom-breath-flower-magnetic-fidget':
      '<rect x="30.5" y="36" width="3" height="20" fill="#2f9a52"/>' +
      '<path d="M22 48q-8-3-9-9 7-1 11 4z" fill="#3bb061"/>' +
      '<g fill="#f7a8d0"><ellipse cx="32" cy="16" rx="7" ry="9"/><ellipse cx="47" cy="27" rx="9" ry="7"/>' +
      '<ellipse cx="41" cy="43" rx="8" ry="8"/><ellipse cx="23" cy="43" rx="8" ry="8"/><ellipse cx="17" cy="27" rx="9" ry="7"/></g>' +
      '<circle cx="32" cy="30" r="8" fill="#f9c61b"/>',

    'donut-delight-sensory-fidget':
      '<circle cx="32" cy="34" r="20" fill="#e3a866"/>' +
      '<path d="M14 30a20 20 0 0 1 36 0 20 20 0 0 1-36 0z" fill="#f786af"/>' +
      '<circle cx="32" cy="34" r="7" fill="#fff8ef"/>' +
      '<rect x="22" y="23" width="5" height="2.4" rx="1.2" fill="#6ad1e0" transform="rotate(25 24 24)"/>' +
      '<rect x="39" y="25" width="5" height="2.4" rx="1.2" fill="#f9c61b" transform="rotate(-25 41 26)"/>' +
      '<rect x="30" y="21" width="5" height="2.4" rx="1.2" fill="#57bd5b" transform="rotate(-5 32 22)"/>' +
      '<rect x="42" y="36" width="5" height="2.4" rx="1.2" fill="#7e6bf0" transform="rotate(40 44 37)"/>',

    'chasing-rainbow-magnetic-fidget':
      '<path d="M7 53a25 25 0 0 1 50 0" fill="none" stroke="#e8554a" stroke-width="5" stroke-linecap="round"/>' +
      '<path d="M13 53a19 19 0 0 1 38 0" fill="none" stroke="#fb9b3a" stroke-width="5" stroke-linecap="round"/>' +
      '<path d="M19 53a13 13 0 0 1 26 0" fill="none" stroke="#f9c61b" stroke-width="5" stroke-linecap="round"/>' +
      '<path d="M25 53a7 7 0 0 1 14 0" fill="none" stroke="#57bd5b" stroke-width="5" stroke-linecap="round"/>',

    'dachshund-darling-magnetic-fidget':
      '<rect x="11" y="32" width="37" height="13" rx="6.5" fill="#c07b35"/>' +
      '<path d="M6 27q-2 8 5 9 3-5 1-9z" fill="#9c5f25"/>' +
      '<rect x="14" y="44" width="4.6" height="11" rx="2.3" fill="#a76a2c"/><rect x="23" y="44" width="4.6" height="11" rx="2.3" fill="#a76a2c"/>' +
      '<rect x="34" y="44" width="4.6" height="11" rx="2.3" fill="#a76a2c"/><rect x="42" y="44" width="4.6" height="11" rx="2.3" fill="#a76a2c"/>' +
      '<circle cx="50" cy="32" r="9" fill="#c07b35"/><path d="M48 24q8-1 6 8-5 0-6-8z" fill="#9c5f25"/>' +
      '<rect x="55" y="33" width="7" height="6" rx="3" fill="#c07b35"/><circle cx="52" cy="31" r="1.7" fill="#2b2c2f"/>',

    'axolotl-pink':
      '<path d="M44 30l11-6-3 8 4 7-12-3z" fill="#f48fb1"/>' +
      '<ellipse cx="29" cy="35" rx="18" ry="10.5" fill="#f7a8c6"/>' +
      '<g fill="#f06fa0"><path d="M15 26q-5-3-3-9 5 2 5 8z"/><path d="M21 23q-3-6 2-10 3 5 0 10z"/><path d="M27 23q0-6 5-9 1 6-3 9z"/></g>' +
      '<circle cx="19" cy="34" r="2.2" fill="#5a2b3f"/><circle cx="13" cy="38" r="2.6" fill="#f49ec0"/>' +
      '<path d="M15 39q5 4 10 0" fill="none" stroke="#c96a8e" stroke-width="2" stroke-linecap="round"/>',

    'axolotl-blue':
      '<path d="M44 30l11-6-3 8 4 7-12-3z" fill="#6fb0e0"/>' +
      '<ellipse cx="29" cy="35" rx="18" ry="10.5" fill="#9cc8ee"/>' +
      '<g fill="#6fb0e0"><path d="M15 26q-5-3-3-9 5 2 5 8z"/><path d="M21 23q-3-6 2-10 3 5 0 10z"/><path d="M27 23q0-6 5-9 1 6-3 9z"/></g>' +
      '<circle cx="19" cy="34" r="2.2" fill="#22405a"/><circle cx="13" cy="38" r="2.6" fill="#8fbfe8"/>' +
      '<path d="M15 39q5 4 10 0" fill="none" stroke="#5a8fc0" stroke-width="2" stroke-linecap="round"/>',

    'tuxedo-kitty-cat-magnetic-fidget':
      '<path d="M14 24l5-11 7 9h12l7-9 5 11v12a18 15 0 0 1-36 0z" fill="#2b2c2f"/>' +
      '<path d="M21 35q11 9 22 0 0 11-11 11t-11-11z" fill="#fff"/>' +
      '<circle cx="25" cy="30" r="3.2" fill="#9be36b"/><circle cx="39" cy="30" r="3.2" fill="#9be36b"/>' +
      '<circle cx="25" cy="30" r="1.3" fill="#1c2a14"/><circle cx="39" cy="30" r="1.3" fill="#1c2a14"/>' +
      '<path d="M30 39h4l-2 2.6z" fill="#f48fb1"/>',

    'dumpster-fire-fidget-magnet':
      '<g fill="#fb8c2a"><path d="M22 36c1-9 6-11 4-18 5 3 8 8 7 13 3-1 4-4 3-8 6 4 9 11 5 17z"/></g>' +
      '<path d="M30 36c0-5 3-7 2-11 3 2 5 6 3 11z" fill="#ffd34d"/>' +
      '<path d="M14 36h36l-3 18H17z" fill="#4a7a55" stroke="#3a6344" stroke-width="1.6"/>' +
      '<rect x="11" y="32" width="42" height="5.5" rx="2.5" fill="#3a6344"/>'
  };

  function get(id) { return I[id] || ''; }
  function has(id) { return !!I[id]; }
  function svg(id, cls) {
    return '<svg class="' + (cls || 'dfa-ico') + '" viewBox="0 0 64 64" aria-hidden="true" focusable="false">' + get(id) + '</svg>';
  }

  return { icons: I, get: get, has: has, svg: svg };
});
